<template>
    <div class="container">
        <h2>Users</h2>
        <div>
            <a href="#" @click.prevent="setStatusFilter('true')"
                :class="{ 'font-weight-bold': statusFilter === 'true' }">Active</a> |
            <a href="#" @click.prevent="setStatusFilter('false')"
                :class="{ 'font-weight-bold': statusFilter === 'false' }">Inactive</a>
        </div>
        <div class="my-3">
            <button class="btn btn-primary" @click="createUser">New User</button>
        </div>
        <div :key="tableContainerKey">
            <table id="usersTable" class="display" style="width:100%">
                <thead>
                    <tr>
                        <th class="text-center">NAME</th>
                        <th class="text-center">EMAIL</th>
                        <th class="text-center">PHONE</th>
                        <th class="text-center">ROLES</th>
                        <th class="text-center">LAST LOGIN</th>
                        <th class="text-center">MFA REQUIRED</th>
                        <th class="text-center">EMAIL VERIFIED</th>
                        <th class="text-center">PHONE VERIFIED</th>
                        <th class="text-center">STATUS</th>
                        <th class="text-center">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in users" :key="user.id">
                        <td>{{ user.firstName }} {{ user.lastName }}</td>
                        <td>{{ user.email }}</td>
                        <td class="text-start">{{ user.phone }}</td>
                        <td>{{ formatRoles(user.userRoles) }}</td>
                        <td class="text-center">{{ user.lastLogin }}</td>
                        <td class="text-center">
                            <i v-if="user.mfaRequired" class="fas fa-check text-success"></i>
                            <i v-else class="fas fa-times text-danger"></i>
                        </td>
                        <td class="text-center">
                            <i v-if="user.emailVerified" class="fas fa-check text-success"></i>
                            <i v-else class="fas fa-times text-danger"></i>
                        </td>
                        <td class="text-center">
                            <i v-if="user.phoneVerified" class="fas fa-check text-success"></i>
                            <i v-else class="fas fa-times text-danger"></i>
                        </td>
                        <td :class="user.active ? 'text-success' : 'text-warning'" class="text-center">
                            {{ user.active ? 'Active' : 'Inactive' }}
                        </td>
                        <td>
                            <button class="btn text-primary" title="Edit" @click="editUser(user.id)">
                                <i class="fas fa-edit"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net-responsive';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import api from '@/api';
import eventBus from '@/utils/eventBus';
import { checkAuth } from '@/utils/auth';

export default {
    data() {
        return {
            users: [],
            statusFilter: 'true', // Default filter for active users
            tableContainerKey: 0 // Changing this key forces the table container to re-render
        };
    },
    async mounted() {
        if (!(await checkAuth())) {
            eventBus.emit('show-alert', { message: 'You need to log in to access this page.', type: 'danger' });
            this.$router.push('/');
        } else {
            await this.fetchUsers();
        }
    },
    methods: {
        async fetchUsers() {
            try {
                const response = await api.get('/v1/users', {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
                    params: { active: this.statusFilter }
                });
                console.log('response:', response);
                if (response.status === 200 && response.data.data) {
                    this.users = Array.isArray(response.data.data.users) ? response.data.data.users : [];
                } else {
                    this.users = [];
                }
                this.tableContainerKey++;
                this.$nextTick(() => {
                    // Use a slight delay to ensure the new table is in place.
                    setTimeout(() => {
                        // Remove any leftover DataTable wrapper from previous instances.
                        if ($.fn.DataTable.isDataTable('#usersTable')) {
                            $('#usersTable').DataTable().destroy(true);
                            $('#usersTable_wrapper').remove();
                        }
                        $('#usersTable').DataTable({
                            responsive: true,
                            columnDefs: [
                                { targets: [8, 9], responsivePriority: 1 }
                            ]
                        });
                    }, 100);
                });
            } catch (error) {
                console.error('Error fetching users:', error);
                this.users = [];
                if (error.response.data.message) {
                    eventBus.emit('show-alert', { message: error.response.data.message, type: 'danger' });
                } else {
                    eventBus.emit('show-alert', { message: 'Error fetching users.', type: 'danger' });
                }
            }
        },
        formatRoles(roles) {
            return roles.map(role => role.code).join(', ');
        },
        async setStatusFilter(status) {
            this.statusFilter = status;
            await this.fetchUsers();
        },
        createUser() {
            this.$router.push('/users/new');
        },
        editUser(userId) {
            this.$router.push(`/users/${userId}`);
        }
    },
    beforeUnmount() {
        if ($.fn.DataTable.isDataTable('#usersTable')) {
            $('#usersTable').DataTable().destroy(true);
            $('#usersTable_wrapper').remove();
        }
    }
};
</script>

<style>
.font-weight-bold {
    font-weight: bold;
}

.col-name {
    width: 15%;
}

.col-email {
    width: 25%;
}

.col-phone {
    width: 15%;
}

.col-status {
    width: 10%;
}

.col-empty {
    width: 5%;
}

.d-none {
    display: none;
}
</style>